import { useEffect } from 'react';

import { isDev } from 'helpers/_helpers';
import { useAppSelector, useAppDispatch } from 'store/store-hooks';
import { useLocation, Path } from 'components/_hooks/use-router';
import { setIsMute } from '../_mediator/audio-track.slice';

export const useWsListeners = (ws: WaveSurfer) => {
  const { path } = useLocation();
  const isMute = useAppSelector((state) => state.audio.isMute);
  const dispatch = useAppDispatch();

  const onMute = (isMute: boolean) => {
    dispatch(setIsMute(isMute));
  };

  useEffect(() => {
    ws.setMute(isMute);
    ws.on('mute', onMute);
    return () => {
      ws.un('mute', onMute);
    };
  }, []);

  useEffect(() => {
    if (isDev()) return;
    if (path === Path.storyboard) ws.setMute(false);
    else if (path === Path.finalcuts) ws.setMute(true);
  }, [path]);
};
